import { render } from "./ExportarCoordMudas.vue?vue&type=template&id=5ddc9d98"
import script from "./ExportarCoordMudas.vue?vue&type=script&lang=js"
export * from "./ExportarCoordMudas.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__